import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import helpers from '../utils/helpers'

function ProtectedRoute({ children, allowedRoles = [],userRole }) {
  const { user, loading } = useAuth()
  const userToken = helpers.getSession('token')
  

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!userToken) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole.role_name)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>
          <p className="text-gray-600">You don't have permission to access this page.</p>
        </div>
      </div>
    )
  }

  return children
}

export default ProtectedRoute